import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.sub";
import "regenerator-runtime/runtime";
import router from '@/router/index';

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

import user from '@/store/modules/d2admin/modules/user';
import routes from './routes';
import setting from '@/setting';
import store from '@/store/index';
import { menuList } from '@/api/apis';
import layoutHeaderAside from '@/layout/header-aside';
import util from '@/libs/util';
var permissionMenu = [];

function importComponent(path) {
  try {
    return _import(path);
  } catch (e) {
    return null;
  }
}

function pushRoute(hotRoute) {
  var data = routes[0].children;
  var isExit = false;
  var toPath = hotRoute.action.substring(1, hotRoute.action.length);

  for (var i in data) {
    if (data[i].path === toPath) {
      isExit = true;
      break;
    }
  }

  if (!isExit) {
    var com = importComponent(hotRoute.controller + hotRoute.action);

    if (com === null) {
      return;
    }

    var routerItem = {
      path: hotRoute.action.substring(1, hotRoute.action.length),
      name: hotRoute.module,
      meta: {
        title: hotRoute.menu_name,
        auth: true,
        cache: true
      },
      component: com
    };
    routes[0].children.push(routerItem);
  }
}

function isRouter(obj) {
  if (!isMenu(obj)) {
    return false;
  }

  if (obj.sub && obj.sub.length > 0) {
    var hasMenu = false;

    for (var i in obj.sub) {
      if (obj.sub[i].is_show === 1) {
        hasMenu = true;
        break;
      }
    }

    if (hasMenu) {
      return false;
    }

    return true;
  }

  return true;
}

function isMenu(obj) {
  return obj.is_show;
}

function convertToMenuAndRoute(obj, aryMenu) {
  var userRules = user.state.info.rules_ids;

  if (userRules.indexOf(obj.id) < 0 && obj.id != 114 && obj.pid != 114) {
    //没有权限
    return;
  }

  if (!isMenu(obj)) {
    //不是菜单
    return;
  }

  var menu = {};
  menu.title = obj.menu_name;
  menu.path = obj.action;
  menu.icon = obj.icon;
  aryMenu.push(menu);

  if (isRouter(obj)) {
    //是路由
    pushRoute({
      controller: obj.controller,
      action: obj.action,
      module: obj.module,
      menu_name: obj.menu_name
    });
  } else {
    menu.children = [];

    for (var i in obj.sub) {
      convertToMenuAndRoute(obj.sub[i], menu.children);
    }
  }
}

function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

export default {
  fetchPermissionInfo: function fetchPermissionInfo() {
    var res, sysMenu, i;
    return regeneratorRuntime.async(function fetchPermissionInfo$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            routes.unshift({
              path: '/',
              redirect: {
                name: 'index'
              },
              component: layoutHeaderAside,
              children: [// 首页
              {
                path: 'index',
                name: 'index',
                meta: {
                  title: '首页',
                  auth: true
                },
                component: _import('system/index')
              }, // { path: 'setting/accountManager', name: '/setting/accountManager', meta: {title: '账户管理', auth: true }, component: _import('pages/setting/accountManager') },
              // { path: 'setting/menuManager', name: '/setting/menuManager', meta: {title: '菜单管理', auth: true }, component: _import('pages/setting/menuManager') },
              // { path: 'setting/roleManager', name: '/setting/roleManager', meta: {title: '角色管理', auth: true }, component: _import('pages/setting/roleManager') },
              {
                path: 'log',
                name: 'log',
                meta: {
                  title: '前端日志',
                  auth: true
                },
                component: _import('system/log')
              }, // 系统 前端日志
              {
                path: 'refresh',
                name: 'refresh',
                hidden: true,
                component: _import('system/function/refresh')
              }, // 刷新页面 必须保留
              {
                path: 'redirect/:route*',
                name: 'redirect',
                hidden: true,
                component: _import('system/function/redirect')
              } // 页面重定向 必须保留
              ]
            });
            _context.next = 3;
            return regeneratorRuntime.awrap(menuList({}));

          case 3:
            res = _context.sent;

            if (util.cookies.get('uuid') == 51) {
              setting.isDev = true;
            }

            if (setting.isDev) {
              sysMenu = {
                "id": 114,
                "pid": 0,
                "icon": "cube",
                "menu_name": "系统配置",
                "module": "sysconfig",
                "controller": "pages",
                "action": "/sysconfig",
                "params": "[]",
                "sort": 100,
                "is_show": 1,
                "access": 1,
                "sub": [{
                  "id": 149,
                  "pid": 114,
                  "icon": "",
                  "menu_name": "规则配置",
                  "module": "systemCreator",
                  "controller": "pages",
                  "action": "/sysconfig/systemCreator/index",
                  "params": "[]",
                  "sort": 0,
                  "is_show": 1,
                  "access": 1,
                  "sub": []
                }, {
                  "id": 156,
                  "pid": 114,
                  "icon": "",
                  "menu_name": "备份管理",
                  "module": "dbBackups",
                  "controller": "pages",
                  "action": "/sysconfig/dbBackups/index",
                  "params": "[]",
                  "sort": 0,
                  "is_show": 1,
                  "access": 1,
                  "sub": []
                } // {
                //   "id": 150,
                //   "pid": 114,
                //   "icon": "",
                //   "menu_name": "前端配置",
                //   "module": "webConfig",
                //   "controller": "pages",
                //   "action": "/sysconfig/webConfig/index",
                //   "params": "[]",
                //   "sort": 10,
                //   "is_show": 1,
                //   "access": 1,
                //   "sub": []
                // }
                ]
              };
              res.push(sysMenu);
            }

            for (i in res) {
              convertToMenuAndRoute(res[i], permissionMenu);
            }

            router.addRoutes(routes);
            store.commit('d2admin/menu/asideSet', permissionMenu);
            store.commit('d2admin/page/init', [routes[0]]); // 加载上次退出时的多页列表

            store.dispatch('d2admin/page/openedLoad');
            _context.next = 13;
            return regeneratorRuntime.awrap(Promise.resolve());

          case 13:
          case "end":
            return _context.stop();
        }
      }
    });
  }
};